let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("aNsqY")).then(() => parcelRequire('5F2lh'));